$(document).ready(function(){
  
  // Gets the Current Active Slick Number
  function getCurrentSlickNo() {
    return $('.testimonials__slide.slick-current.slick-active').data('slick-index');
  } 

  // Changes the Slick Slide, left or right
  function changeSlide(direction = 'right') {
    var slideno = $('.testimonials__slide.slick-current.slick-active').data('slick-index');
    if(direction == 'right') {
      $('.testimonials__slider__inner').slick('slickGoTo', slideno + 1);
    } else {
      $('.testimonials__slider__inner').slick('slickGoTo', slideno - 1);
    }
  }

  // Appends the corresponding information of the Slide
  function appendTestimonialText() {
    var active_testimonial = $('.testimonials__slide.slick-current.slick-active');
    var testimonial_text = $('[data-testimonial-text]');
    testimonial_text.find('[data-testimonial-body]').text($.trim(active_testimonial.find('[data-testimonial-body]').text()));
    testimonial_text.find('[data-testimonial-person-name]').text($.trim(active_testimonial.find('[data-testimonial-person-name]').text()));
    testimonial_text.find('[data-testimonial-person-title]').text($.trim(active_testimonial.find('[data-testimonial-person-title]').text()));
    testimonial_text.addClass('bgp-fade-in');
    setTimeout(function(){
        testimonial_text.removeClass('bgp-fade-in');
    },200);
  }

  // resizes the testimonial slider overlay
  function overlayAdjust() {
    var active_testimonial = $('.testimonials__slide.slick-current.slick-active');
    var testimonial_slider_overlay = $("[data-testimonial-slider-overlay]");
    var active_testimonial_outerwidth = active_testimonial.outerWidth();
    if(testimonial_slider_overlay.length && active_testimonial_outerwidth) {
        var o = active_testimonial_outerwidth + parseFloat(active_testimonial.find(".testimonials__item").css("padding-left"));
        testimonial_slider_overlay.css("left", o.toString()+"px");
    }
  }

  // Fires after Slick is initialized
  $('.testimonials__slider__inner').on('init', function(event, slick) {
    appendTestimonialText();
  });

  // Fires after swiping the Slick slide
  $('.testimonials__slider__inner').on('swipe', function(event, slick, direction) {
    changeSlide(direction);
    appendTestimonialText();
  });

  // Fires after position/size changes, adjusts testimonial slider overlay
  $('.testimonials__slider__inner').on('setPosition', function(event, slick, direction) {
    overlayAdjust();  
  });

  // Initializes Slick
  $('.testimonials__slider__inner').slick({
    arrows: false,
    draggable: false,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    variableWidth: true
  });

  // Fires when left button is clicked
  $('[data-testimonial-slider-prev]').click(function(e) {
    e.preventDefault();
    changeSlide('left');
    appendTestimonialText();
  });

  // Fires when right button is clicked
  $('[data-testimonial-slider-next]').click(function(e) {
    e.preventDefault();
    changeSlide('right');
    appendTestimonialText();
  });
  
  // Product Page //
  // Slick Feature Block
  // Initializes Slick
  $('.js-slider--feature-slider').slick({
    dots: true,
    infinite: false,
    centerMode: false,
    arrows: false,
    slidesToShow: 1,
    mobileFirst: true,
    focusOnSelect: true,
    asNavFor: ".js-slider--feature-slider-image",
    variableWidth: false,
    responsive:[
        {
            breakpoint: 768,
            settings:
            {
              slidesToShow: 4,
              slidesToScroll: 4,
              dots: false,
            }
        }
    ]
  });

  $(".js-slider--feature-slider-image").slick({
      dots: false,
      infinite: false,
      centerMode: false,
      arrows: false,
      slidesToShow: 1,
      fade: true,
      asNavFor:'.js-slider--feature-slider'
  });
  $('.js-slider--feature-slider').on("click",".slick-slide", function(e){
      var slick_index = $(this).data("slick-index");
      var image_slick = $(".js-slider--feature-slider-image").slick("getSlick");
      image_slick.slickGoTo(slick_index, !0);
  });

  // Custom Accordion
  $(".js-collapse-trigger").click(function() {
      var collapse_parent = $(this).parent('.js-collapse-parent');
      if(collapse_parent.hasClass('collapse-open')) {
          collapse_parent.removeClass('collapse-open').find('> .js-collapse-content').slideUp();
      } else {
          $('.collapse-open').removeClass('collapse-open').find('> .js-collapse-content').slideUp();
          collapse_parent.addClass('collapse-open').find('> .js-collapse-content').slideDown();
      }
  });
  
  $(".js-product-press-logos").slick({
    'slidesToShow': 8,
    'slidesToScroll': 8,
    'dots': false,
    'infinite': false,
    'arrows': false,
    'centerMode': false,
    'variableWidth': false,
    'responsive': [{
      'breakpoint': 769,
      'settings': {
        'slidesToShow': 4,
        'slidesToScroll': 1,
        'variableWidth': false,
        'centerMode': false,
        'infinite': true,
        'autoplay': true,
        'autoplaySpeed': 2000
      }
    }]
  });
  
  /* Skipping Cart Page */
  function enableAddToCartBtn($addToCartBtn) {
    setTimeout( function(){ 
    	$addToCartBtn.removeClass('disabled').removeClass("active").prop('disabled', false);
    }  , 5000 );
  }
  
  $(".ajax-cart-form").on('submit', function(e) {
  	e.preventDefault();
    var $addToCartForm = $("#ajax-cart-form");
    var $addToCartBtn = $(".add_to_cart_btn");
    var $shopifyAjaxAddURL = '/cart/add.js';
    var $shopifyAjaxChangeURL = '/cart/change.js';
    var $shopifyAjaxCartURL = $shopifyAjaxAddURL;
    $addToCartBtn.addClass('disabled').addClass("active").prop('disabled', true);
    
      $.getJSON('/cart.js', function(cart) {
        
        if(cart.item_count) {
          $shopifyAjaxCartURL = $shopifyAjaxChangeURL;
        } else {
          $shopifyAjaxCartURL = $shopifyAjaxAddURL;
        }
        
        // Add item to cart
        $.ajax({
          url: $shopifyAjaxCartURL,
          dataType: 'json',
          type: 'post',
          data: $addToCartForm.serialize(),
          success: function(itemData) {
            $("#goToCheckout").trigger("click");
            enableAddToCartBtn($addToCartBtn);
          },
          error: function() {
            enableAddToCartBtn($addToCartBtn);
          }
        });
        
      });
    
  });
  
  
  /* Toggle Video Modal
  -----------------------------------------*/
	function toggle_video_modal() {
	    // Click on video thumbnail or link
	    $(".js-trigger-video-modal").on("click", function(e){
          // prevent default behavior for a-tags, button tags, etc. 
	        e.preventDefault();
          
          // Grab the video ID from the element clicked
          var id = $(this).attr('data-youtube-id');
          
          // Autoplay when the modal appears
          // Note: this is intetnionally disabled on most mobile devices
          // If critical on mobile, then some alternate method is needed
          var autoplay = '?autoplay=1';

          // Don't show the 'Related Videos' view when the video ends
          var related_no = '&rel=0';

		  // String the ID and param variables together
          var src = '//www.youtube.com/embed/'+id+autoplay+related_no;
//           var src = 'https://cdn.shopify.com/s/files/1/0401/0347/7398/files/Maxim_s_Skin_Bundle-edited2small.mp4?v=1590947270';
          
          // Pass the YouTube video ID into the iframe template...
          // Set the source on the iframe to match the video ID
          $("#modal-youtube").attr('src', src);
          
          // Add class to the body to visually reveal the modal
          $("body").addClass("show-video-modal noscroll");
	    
      });

	    // Close and Reset the Video Modal
      function close_video_modal() {
        event.preventDefault();
        // re-hide the video modal
        $("body").removeClass("show-video-modal noscroll");
        // reset the source attribute for the iframe template, kills the video
        $("#modal-youtube").attr('src', '');
      }
      
      // if the 'close' button/element, or the overlay are clicked 
	    $('body').on('click', '.close-video-modal, .video-modal .overlay', function(event) {
          // call the close and reset function
          close_video_modal();
      });
      
      // if the ESC key is tapped
      $('body').keyup(function(e) {
          // ESC key maps to keycode `27`
          if (e.keyCode == 27) { 
            // call the close and reset function
            close_video_modal();
          }
      });
      
	}
	toggle_video_modal();

});